"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAxisToSvg = addAxisToSvg;
exports.createSvg = createSvg;
exports.createXScale = createXScale;
exports.createYScale = createYScale;
exports.drawLegend = drawLegend;
exports.drawRects = drawRects;
exports.drawTicks = drawTicks;
exports.getGradients = getGradients;
exports.rotateBottomTicks = rotateBottomTicks;
var d3 = _interopRequireWildcard(require("d3"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function createXScale(isPercentage, data, stackKeys, marginLeft, width) {
  let maxReducer = d => stackKeys.reduce((sum, k) => sum + d[k], 0);
  let xMax = isPercentage ? 100 : d3.max(data, maxReducer);
  let xScale = d3.scaleLinear().domain([0, xMax]).nice().range([marginLeft, width - 16]);
  return xScale;
}
function createYScale(groups, rangeMax) {
  let yScale = d3.scaleBand().domain(groups).range([0, rangeMax]).padding(0).paddingInner(0);
  return yScale;
}
function getGradients(domainMax, overridingGradients) {
  let gradients = {
    ownValue: d3.scaleOrdinal().domain([0, domainMax]).range(overridingGradients?.ownValue ? overridingGradients.ownValue : ['#2f9789', '#f3443d', '#e5005f', '#da9d7e', '#b1967e', '#8baddb']),
    average: d3.scaleOrdinal().domain([0, domainMax]).range(overridingGradients?.average ? overridingGradients.average : ['#2fb789', '#f3743d', '#e6005f', '#dacd7e', '#b1997e', '#8caddb'])
  };
  return gradients;
}
function createSvg(ref, width, height) {
  let svg = d3.select(ref.current).attr('width', width).attr('height', height);
  return svg;
}

// prettier-ignore
function addAxisToSvg(svg, xTranslate, yTranslate, location, axis, className, threshold) {
  let locationsMap = {
    left: d3.axisLeft(axis),
    bottom: d3.axisBottom(axis)
  };
  let selectedAxis = locationsMap[location];
  svg.append('g').attr('transform', `translate(${xTranslate},${yTranslate})`).attr('class', className).call(selectedAxis.tickSize(8).tickSizeOuter(0)).call(g => g.selectAll('.domain, .tick line').attr('stroke', '#8d8d8d')).call(g => g.selectAll('.tick line').attr('display', 'none')).call(g => g.selectAll('.tick text').text(text => {
    if (threshold) {
      let textLength = text.length;
      if (textLength > threshold) {
        let trunctedText = text.substring(0, threshold);
        trunctedText = trunctedText.replace(/.{3}$/, '...');
        return trunctedText;
      }
    }
    return text;
  }));
}
function drawRect(selector, container, d, key, barWidth, xStart, yStart, isPercentage, gradients, idx, x) {
  const BAR_HEIGHT = 10;
  d3.select(selector).append('rect').on('mousemove', event => mousemoveListener(container, d, isPercentage, event, key)).on('mouseout', () => mouseoutListener(container)).attr('x', xStart).attr('y', yStart).attr('width', barWidth).attr('height', BAR_HEIGHT).attr('fill', isPercentage ? gradients[d.subgroup](idx) : d.subgroup.toLowerCase() === 'average' ? '#0000000' : '#e41a11');
}
function drawWhiteLineBetweenRects(selector, xStart, yStart, barWidth) {
  const LINE_BETWEEN_RECTS_HEIGHT = 10;
  const LINE_BETWEEN_RECTS_WIDTH = '1';
  const LINE_BETWEEN_RECTS_COLOR = '#ffffff';
  d3.select(selector).append('path').attr('d', `M${xStart + barWidth} ${yStart} V${yStart + LINE_BETWEEN_RECTS_HEIGHT} Z`).attr('stroke-width', LINE_BETWEEN_RECTS_WIDTH).attr('stroke', LINE_BETWEEN_RECTS_COLOR);
}
function drawRects(svg, isPercentage, groupedData, x, y0, y1, stackKeys, width, marginLeft, container, gradients) {
  svg.append('g').selectAll('g').data(groupedData).join('g').attr('transform', d => `translate(0,${y0(d[0])})`).selectAll('g').data(d => d[1]).join('g').attr('transform', d => `translate(0,${y1(d.subgroup)})`).each(function (d, index) {
    let xStart = x(0);
    let yStart = index % 2 === 0 ? 1 : y1.bandwidth() - 11;
    stackKeys.forEach((key, idx) => {
      let xOffset = idx === 0 ? 0 : 1;
      // sum up all properties which are numbers
      const total = Object.values(d).filter(e => Number.parseFloat(e)).reduce((acc, val) => acc + val, 0);
      // calculte the percentage for this value
      const percentage = d[key] / total * 100;
      // calculate the rect width based on its percenate or value
      let barWidth = isPercentage ? percentage / 100 * (width - marginLeft - 16) : x(d[key]) - x(0);
      xStart += xOffset;
      barWidth -= xOffset;
      const selector = this;
      drawRect(selector, container, d, key, barWidth, xStart, yStart, isPercentage, gradients, idx, x);
      if (idx !== stackKeys.length - 1) {
        drawWhiteLineBetweenRects(selector, xStart, yStart, barWidth);
      }
      xStart += barWidth;
    });
  });
}
function mousemoveListener(container, d, isPercentage, event, key) {
  const total = Object.values(d).filter(e => Number.parseFloat(e)).reduce((acc, val) => acc + val, 0);
  const percentage = d[key] / total * 100;
  let value = isPercentage ? percentage : d[key];
  let tooltip = container.querySelector('.tooltip-inner');
  if (!tooltip) {
    tooltip = document.createElement('div');
    tooltip.classList.add('tooltip-inner');
  }
  tooltip.innerHTML = `
      <div>${key}</div>
      <div>${value.toFixed(2)}</div>`;
  tooltip.style.display = 'flex';
  container.appendChild(tooltip);
  let {
    width: containerWidth
  } = container.getBoundingClientRect();
  let {
    width: tooltipWidth,
    height: tooltipHieght
  } = tooltip.getBoundingClientRect();
  if (tooltipWidth + event.offsetX >= containerWidth) {
    tooltip.style.left = Math.floor(event.offsetX - tooltipWidth - 16) + 'px';
    tooltip.style.top = event.offsetY - tooltipHieght + 10 + 'px';
  } else {
    tooltip.style.left = event.offsetX + 16 + 'px';
    tooltip.style.top = event.offsetY - 10 + 'px';
  }
}
function mouseoutListener(container) {
  let tooltip = container.querySelector('.tooltip-inner');
  if (tooltip) {
    tooltip.style.display = 'none';
  }
}
function rotateBottomTicks(container, y) {
  let bottomAxisTickGroups = container.querySelectorAll('.xAxis');
  let yBandWidth = y.bandwidth();
  bottomAxisTickGroups.forEach(bottomAxis => {
    let ticks = bottomAxis.querySelectorAll('.tick');
    ticks.forEach(tick => {
      let text = tick.querySelector('text');
      let {
        x,
        y,
        width
      } = text.getBBox();
      text.setAttribute('transform', `rotate(-90)
        translate(${-1 * x - width - 8},${y - yBandWidth / 2})
        `);
    });
  });
}
function drawLegend(svgHeight, isPercentage, subgroups, svg, xTranslate, stackKeys, gradients) {
  const LEGEND_Y = svgHeight - 50;
  const RECT_SIDE_LENGTH = 16;
  const GAP = 16;
  if (isPercentage) {
    let {
      width,
      x
    } = svg.node().getBBox();
    let svgWidth = width + x;
    let legendContainer = svg.append('foreignObject').attr('width', svgWidth - xTranslate).attr('height', subgroups.length * RECT_SIDE_LENGTH + GAP).attr('transform', `translate(${xTranslate},${LEGEND_Y})`).append('xhtml:div').style('position', 'fixed').attr('class', 'legend-container');
    subgroups.forEach(subgroup => {
      const legendRow = legendContainer.append('xhtml:div').attr('class', 'legend-row');
      stackKeys.forEach((key, i) => {
        let legendItem = legendRow.append('xtml:div').attr('class', 'legend-item');
        legendItem.append('xhtml:div').style('width', `${RECT_SIDE_LENGTH}px`).style('height', `${RECT_SIDE_LENGTH}px`).style('background', `${gradients[subgroup](i)}`);
        legendItem.append('xhtml:div').style('white-space', 'nowrap').html(key);
      });
    });
  }
}
function drawTicks(width, marginLeft, marginBottom, svgHeight, legendSpace) {
  const PADDING = 16;
  d3.selectAll('g.yAxis g.tick').append('line').attr('class', 'gridline').attr('x1', 0).attr('y1', 0).attr('x2', width - marginLeft - PADDING).attr('y2', 0).attr('stroke', '#e0e0e0');
  d3.select('g.yAxis').append('line').attr('class', 'gridline').attr('x1', 0).attr('y1', -marginBottom).attr('x2', width - marginLeft - PADDING).attr('y2', -marginBottom).attr('stroke', '#e0e0e0').attr('transform', 'translate(0,40)');
  d3.selectAll('g.xAxis g.tick').append('line').attr('class', 'gridline').attr('x1', 0).attr('y1', -svgHeight + legendSpace).attr('x2', 0).attr('y2', 0).attr('stroke', '#e0e0e0');
}